import { InputEntity } from "..";

export class UserRegisterInput extends InputEntity {
  public readonly public_id: string;
  public constructor(
    public readonly recaptchaToken: string | null,
    public readonly email: string,
    public_id: string,
    public readonly password: string,
    public readonly first_name: string,
    public readonly last_name: string,
    public readonly lc: string,
    public readonly year: number,
    public readonly is_medicine: boolean,
    public readonly programme_title: string | null,
    public readonly series: number,
    public readonly group: number,
    public readonly registration_number: string,
    public readonly id_image?: File
  ) {
    super();
    const pattern = /^[a-z][a-z0-9_.-]*$/;

    public_id = public_id.trim();

    if (!pattern.test(public_id))
      throw new Error(
        "Id-ul public poate conține doar litere mici, cifre și caracterele _ . - și trebuie să înceapă cu o literă."
      );

    this.public_id = public_id;
  }
}

export class UserUpdateInput extends UserRegisterInput {
  public constructor(
    public readonly current_password: string,
    email: string,
    public_id: string,
    password: string,
    first_name: string,
    last_name: string,
    lc_id: string,
    year: number,
    is_medicine: boolean,
    programme_title: string,
    series: number,
    group: number,
    registration_number: string,
    id_image?: File
  ) {
    super(
      null,
      email,
      public_id,
      password,
      first_name,
      last_name,
      lc_id,
      year,
      is_medicine,
      programme_title,
      series,
      group,
      registration_number,
      id_image
    );
  }
}
